export default "__VITE_ASSET__BsU5UBSp__"